{
  "header": {
    "title": "Meldingen",
    "description": "Word gewaarschuwd wanneer je laadstations of sessies aandacht nodig hebben."
  },
  "noAccess": {
    "title": "Geen toegang",
    "description": "We konden je account niet laden. Probeer het zo weer."
  },
  "table": {
    "title": "Meldingsregels",
    "count": "{{count}} meldingen",
    "count_one": "{{count}} melding",
    "count_other": "{{count}} meldingen",
    "searchPlaceholder": "Meldingen zoeken",
    "searchAria": "Meldingen op naam zoeken",
    "columns": {
      "name": "Melding",
      "owner": "Eigenaar",
      "type": "Type",
      "schedule": "Interval",
      "lastRun": "Laatste run",
      "status": "Status"
    },
    "empty": {
      "title": "Nog geen meldingen",
      "description": "Maak een melding om je stations of sessies in de gaten te houden."
    },
    "error": {
      "title": "Meldingen laden mislukt",
      "description": "Er ging iets mis. Probeer het zo weer."
    }
  },
  "types": {
    "ChargingStation": "Laadstation",
    "Transaction": "Transactie"
  },
  "status": {
    "active": "Actief",
    "inactive": "Inactief"
  },
  "execStatus": {
    "Success": "Problemen gevonden",
    "NoData": "Alles in orde",
    "Failed": "Mislukt"
  },
  "interval": {
    "minutes": "Elke {{count}} minuten",
    "minutes_one": "Elke minuut",
    "minutes_other": "Elke {{count}} minuten",
    "hours": "Elke {{count}} uur",
    "hours_one": "Elk uur",
    "hours_other": "Elke {{count}} uur"
  },
  "lastRun": {
    "never": "Nog niet uitgevoerd",
    "found": "{{count}} items",
    "found_one": "{{count}} item",
    "found_other": "{{count}} items"
  },
  "actions": {
    "new": "Nieuwe melding",
    "edit": "Bewerken",
    "delete": "Verwijderen",
    "cancel": "Annuleren",
    "save": "Opslaan",
    "enable": "Inschakelen",
    "disable": "Uitschakelen",
    "history": "Uitvoeringsgeschiedenis"
  },
  "form": {
    "addTitle": "Nieuwe melding",
    "editTitle": "Melding bewerken",
    "description": "Kies wat je wilt bewaken en hoe vaak er gecontroleerd wordt.",
    "fields": {
      "name": "Naam",
      "recipients": "Ontvangers",
      "type": "Type melding",
      "interval": "Uitvoeren elke",
      "startFrom": "Starten vanaf",
      "active": "Actief",
      "staleDuration": "Langer bezig dan (minuten)",
      "maxEnergy": "Energie boven (kWh)",
      "lowSoc": "Laadtoestand onder (%)",
      "emailTemplate": "E-mailbericht"
    },
    "placeholders": {
      "name": "bijv. Stations met storing",
      "recipients": "naam@voorbeeld.nl, ops@voorbeeld.nl",
      "type": "Kies een type",
      "emailTemplate": "Laat leeg voor het standaardbericht, of schrijf je eigen bericht met de parameters hieronder."
    },
    "sections": {
      "stationStatuses": "Laadstation-status",
      "socketStatuses": "Socket-status",
      "transactionConditions": "Waarschuw wanneer een sessie…",
      "emailMessage": "E-mailbericht"
    },
    "hints": {
      "active": "Als de melding actief is, draait deze volgens het schema. Zet uit om te pauzeren zonder te verwijderen.",
      "recipients": "Komma-gescheiden e-mailadressen die een melding krijgen als dit afgaat.",
      "startFrom": "Laat leeg om direct te starten.",
      "emailTemplate": "Klik op een parameter om deze in te voegen. Laat het bericht leeg voor het standaardbericht."
    },
    "errors": {
      "name": "Voer een naam in.",
      "recipients": "Voer minstens één geldig e-mailadres in.",
      "statuses": "Kies minstens één status.",
      "conditions": "Schakel minstens één voorwaarde in en geef een waarde op."
    }
  },
  "stationStatus": {
    "OFFLINE": "Offline"
  },
  "socketStatus": {
    "FAULTED": "Storing",
    "INOPERATIVE": "Buiten werking",
    "OCCUPIED": "Bezet",
    "RESERVED": "Gereserveerd",
    "AVAILABLE": "Beschikbaar",
    "UNKNOWN": "Onbekend"
  },
  "conditions": {
    "stale": "Te lang bezig",
    "energy": "Te veel energie",
    "lowSoc": "Gestopt met lage laadtoestand"
  },
  "deleteDialog": {
    "title": "Melding verwijderen?",
    "description": "\"{{name}}\" en de uitvoeringsgeschiedenis verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "confirm": "Verwijderen"
  },
  "executions": {
    "title": "Uitvoeringsgeschiedenis",
    "empty": {
      "title": "Nog geen uitvoeringen",
      "description": "Deze melding is nog niet uitgevoerd."
    },
    "columns": {
      "when": "Wanneer",
      "status": "Resultaat",
      "items": "Items",
      "summary": "Samenvatting"
    },
    "error": {
      "title": "Geschiedenis laden mislukt",
      "description": "Er ging iets mis. Probeer het zo weer."
    }
  },
  "toasts": {
    "saved": "Melding opgeslagen.",
    "saveFailed": "Melding opslaan mislukt.",
    "deleted": "Melding verwijderd.",
    "deleteFailed": "Melding verwijderen mislukt.",
    "toggled": "Melding bijgewerkt.",
    "toggleFailed": "Melding bijwerken mislukt."
  },
  "owner": {
    "tenant": "Tenant",
    "organisation": "Organisatie",
    "wholeFleet": "Volledige vloot",
    "wholeFleetHint": "Alle laadpunten"
  }
}
